import { Mail, MapPin, Phone, Clock } from "lucide-react";
import { business } from "../config/site.config";
import { Logo } from "./Logo";
import { NAV } from "./Header";
import { Reveal } from "./Sections";

export const Contact = () => (
  <footer id="contact" className="on-dark bg-charcoal pb-28 pt-24 text-beige sm:pt-32 md:pb-10" data-testid="contact-section">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.22em] text-beige/70">Contact</p>
        <a href={business.phoneHref} className="mt-6 block font-display text-[15vw] font-bold leading-[0.9] tracking-tight transition-colors hover:text-ember-light sm:text-[11vw] lg:text-[9vw]" data-testid="contact-phone-link">
          {business.phoneDisplay}
        </a>
      </Reveal>
      <div className="mt-16 grid gap-10 border-t border-beige/15 pt-12 sm:grid-cols-2 lg:grid-cols-[1fr_1.4fr_1fr_0.8fr]">
        <div className="flex flex-col gap-4">
          <Logo dark />
          <p className="text-sm text-beige/80" data-testid="footer-credentials">{business.credentials.join(" · ")}</p>
        </div>
        <ul className="flex min-w-0 flex-col gap-2 text-sm">
          <li><a href={business.phoneHref} className="flex min-h-11 items-center gap-3 hover:text-ember-light" data-testid="footer-phone-link"><Phone className="h-4 w-4 shrink-0 text-ember-light" /> {business.phoneDisplay}</a></li>
          <li>
            <a href={`mailto:${business.email}`} className="flex min-h-11 items-center gap-3 hover:text-ember-light" data-testid="footer-email-link">
              <Mail className="h-4 w-4 shrink-0 text-ember-light" />
              <span className="whitespace-nowrap text-[13px] [overflow-wrap:normal] sm:text-sm">{business.email}</span>
            </a>
          </li>
        </ul>
        <ul className="flex flex-col gap-4 text-sm">
          <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-ember-light" /> <span>Serving {business.serviceArea}</span></li>
          <li className="flex gap-3" data-testid="footer-hours"><Clock className="mt-0.5 h-4 w-4 shrink-0 text-ember-light" /> <span>{business.hours}</span></li>
        </ul>
        <nav aria-label="Footer" className="flex flex-col text-sm">
          {[...NAV, { href: "#estimate", label: "Book an estimate" }].map((n) => (
            <a key={n.href} href={n.href} className="flex min-h-11 w-fit items-center text-beige/85 hover:text-ember-light" data-testid={`footer-nav-${n.href.slice(1)}`}>{n.label}</a>
          ))}
        </nav>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-beige/15 pt-6 text-xs text-beige/70 md:flex-row md:justify-between">
        <p>
          © {new Date().getFullYear()} {business.name}. All rights reserved. ·{" "}
          <a href="/privacy" className="inline-flex min-h-11 items-center underline underline-offset-2 hover:text-ember-light md:min-h-0" data-testid="footer-privacy-link">Privacy policy</a> ·{" "}
          <a href="/terms" className="inline-flex min-h-11 items-center underline underline-offset-2 hover:text-ember-light md:min-h-0" data-testid="footer-terms-link">Terms &amp; Conditions</a>
        </p>
        <p className="max-w-xl md:text-right">Color inspiration scenes are illustrations made for this website, not photographs of SAB projects. On-screen colors are approximate — confirm with physical samples.</p>
      </div>
    </div>
  </footer>
);
